// Path: ./src/app/components/TopRightCornerCloseButton/CloseButton.tsx
import React from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { SxProps, Theme } from "@mui/material";

// Define a type for the onClose prop using TypeScript
type CloseButtonProps = {
  onClose: () => void;
  sx?: SxProps<Theme> | undefined;
};
const CloseButton = ({ onClose, sx }: CloseButtonProps) => {
  return (
    <IconButton
      data-testid="top right close button"
      aria-label="close"
      onClick={onClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
        ...sx,
      }}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default CloseButton;
